import { render, staticRenderFns } from "./LocaleSelect.vue?vue&type=template&id=ce6b461e&"
import script from "./LocaleSelect.vue?vue&type=script&lang=js&"
export * from "./LocaleSelect.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSelect.vue?vue&type=style&index=0&id=ce6b461e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports